import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  background-color: white;
  border-radius: 8px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 5px;
`;

const Title = styled.h4`
  margin: 0;
  color: #333;
  font-weight: 600;
`;

const BackButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #007bff;
  background-color: white;
  color: #007bff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background-color: #007bff;
    color: white;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const AllWoFields = [
  'title',
  'woType',
  'description',
  'episode',
  'trailerEpisodeName',
  'tag',
  'replacementNumber',
  'clientName',
  'distributor',
  'qcProfile',
  'qcType',
  'videoStandard',
  'format',
  'resolution',
  'colorSpace',
  'textless',
  'caption',
  'audioConfiguration',
  'runtime',
  'turnaroundTimeHours',
  'qcStatus',
  'createdAt',
  'updatedAt',
];

export const prepareFieldLabel = k => {
  if (k === 'clientName') {
    return 'Studio';
  }
  if (k === 'videoStandard') {
    return 'Standard';
  }
  const label = k.replace(/([A-Z]|[0-9]+)/g, ' $1');
  const idx = (label.startsWith('qc ') || label.startsWith('wo ')) ? 2 : 1;
  return label.substr(0, idx).toUpperCase() + label.substr(idx);
};

export const prepareFieldValue = (data, k) => {
  if (k === 'runtime') {
    const runtimeStr = data[k];
    if (typeof runtimeStr === 'string' && /^[0-9]+$/.test(runtimeStr)) {
      const runtimeSeconds = +runtimeStr;
      const sec = runtimeSeconds % 60;
      const totalMinute = Math.floor(runtimeSeconds / 60);
      const min = totalMinute % 60;
      const hour = Math.floor(totalMinute / 60);
      return String(hour).padStart(2, '0') + ':' + String(min).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
    }
    return runtimeStr;
  }
  if (['createdAt', 'updatedAt'].includes(k)) {
    return data[k + 'OnTzPst'];
  }
  return data[k];
};

const WorkOrderDetailsView = ({ workOrderData, onClose }) => {
  if (!workOrderData) return null;

  return (
    <Container>
      <Header>
        <Title>Work Order Details</Title>
        <BackButton onClick={onClose}>
          Back to Search
        </BackButton>
      </Header>

      <div>
          {AllWoFields.map(k => {
            const v = prepareFieldValue(workOrderData, k);
            return !!v && (
              <React.Fragment key={k}>
                <dl
                  style={{marginBottom: '3px', fontWeight: 'bold'}}
                >
                  {prepareFieldLabel(k)}
                </dl>
                <dd>
                  {v}
                </dd>
              </React.Fragment>
            );
          })}
        </div>
    </Container>
  );
};

WorkOrderDetailsView.propTypes = {
  workOrderData: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

WorkOrderDetailsView.defaultProps = {
  workOrderData: null,
};

export default WorkOrderDetailsView;